import { apiClient } from '@/lib/api-client'
import type { Layer, Mention, MentionsResponse } from '@/types/terms'

/**
 * All occurrences of a term. Unbounded by design on the backend — the most
 * frequent term returns ~17k mentions (~7 MB) — so the list is virtualised and
 * this query is only fired for the selected term.
 */
export async function getMentions(termId: number, layer: Layer): Promise<Mention[]> {
  const { data } = await apiClient.get<MentionsResponse>(`/terms/${termId}/mentions`, {
    params: { layer },
  })
  return data.mentions ?? []
}
